<template>
    <div class="container">
        <div class="form-top">
            <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="2">
                    告警列表
                </el-col>
                <el-col :span="3" v-if="!projectId">
                    <el-select placeholder="选择目标" v-model="searchForm.projectId" clearable @change="pageChange(1)">
                        <el-option v-for="item of projectNameList" :label="item.name" :value="item.id" :key="item.id"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="3" v-if="!projectId">
                    <el-select placeholder="选择模版" v-model="searchForm.modelId" clearable @change="pageChange(1)" no-data-text="请先选择目标">
                        <el-option v-for="item of alarmModelNameList" :label="item.name" :value="item.id" :key="item.id"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="8">
                    <el-radio-group v-model="searchForm.radioIndex" @change="onRadioChange">
                        <el-radio-button v-for="item of radioGroupList" :key="item.value" :label="item.value">
                            {{item.label}}
                        </el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col :span="3">
                    <a-range-picker v-model="searchForm.date" allowClear @change="onDateChange" />
                </el-col>
            </el-row>
        </div>
        <div class="form-container">
            <el-table :data="alarmList" style="width: 100%" size="medium" :header-cell-style="{height: '50px'}"
                :row-style="{height: '50px',padding: '5px 0'}">
                <el-table-column label="告警项" width="200" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span style="font-weight: 500;font-size: 15px;">
                            {{scope.row.alarm_model.name}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="告警类型" width="120">
                    <template slot-scope="scope">
                        <el-tag effect="dark" :type="alarmLevelTagFilter(scope.row.alarm_model.level)">
                            {{scope.row.alarm_model.level | alarmLevelFilter}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="告警内容" prop="content" min-width="200" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column label="状态" width="100">
                    <template slot-scope="scope">
                        {{scope.row.status | alarmStatusFilter}}
                    </template>
                </el-table-column>
                <el-table-column label="目标" width="120">
                    <template slot-scope="scope">
                        {{scope.row.alarm_model.project_name}}
                    </template>
                </el-table-column>
                <el-table-column label="告警对象" prop="source_id" width="120">
                </el-table-column>
                <el-table-column label="持续时间" width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.row.response_time < 60">{{scope.row.response_time + '秒'}}</span>
                        <span v-else>{{scope.row.response_time / 60 | timeStamp}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="告警时间" width="200">
                    <template slot-scope="scope">
                        {{scope.row.create_time | timeFilter}}
                    </template>
                </el-table-column>
                <el-table-column label="通知对象" width="200" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span style="font-weight: 500;" v-for="(binder) of scope.row.alarm_model.bind_receivers" :key="binder.id">
                            {{binder.name}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="130" fixed='right'>
                    <template slot-scope="scope">
                        <el-button icon="el-icon-coin" size="mini" @click="handleCodeShow(scope.row.data)">查看数据</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination background layout="prev, pager, next" :page-size="10" :total="total"
                    @current-change="pageChange" :current-page="currentPage"></el-pagination>
            </div>
            <el-dialog
                title="原始数据"
                :visible.sync="codeVisible"
                width="30%"
                :closed="handleCodeClosed"
            >
                <div>
                    <json-viewer :value="code" :expand-depth="3"></json-viewer>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="codeVisible = false">关闭</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import Core from '../../../core';
import dayjs from 'dayjs';

export default {
    props: {
        projectId: {
            default: 0
        }
    },
    data() {
        return {
            searchForm: {
                date: null,
                beginTime: null,
                endTime: null,
                radioIndex: null,
                projectId: null,
                modelId: null,
            },
            radioGroupList: [
                { label: '不限', value: '' },
                { label: '1小时', value: '1' },
                { label: '4小时', value: '2' },
                { label: '12小时', value: '3' },
                { label: '1天', value: '4' },
                { label: '3天', value: '5' },
                { label: '7天', value: '6' }
            ],
            alarmList: [],
            total: 0,
            currentPage: 1,

            projectNameList: [],
            alarmModelNameList: [],
            codeVisible: false,
            code: ''
        };
    },
    watch: {
        'searchForm.projectId'(newVal, oldVal) {
            Core.Api.AlarmModel.nameList(newVal).then(res => {
                this.alarmModelNameList = res.alarm_model_name_list
            })
        }
    },
    mounted() {
        this.getAlarmList();
        if (!this.projectId) {
            this.getNameList()
        }
    },
    methods: {
        handleCodeShow(data){ 
            if (data) {
                this.code = JSON.parse(data)
                this.codeVisible = true; 
            }else {
                this.$message.warning('该告警项无原始数据')
            }
        },
        handleCodeClose(){ this.codeVisible = false; },
        handleCodeClosed(){},
        alarmLevelTagFilter(value) {
            return Vue.filter('alarmLevelTagFilter')(value)
        },
        onDateChange(date, dateString) {
            this.searchForm.beginTime = dateString[0] ? dayjs(dateString[0]).unix() : '';
            this.searchForm.endTime = dateString[1] ? dayjs(dateString[1]).unix() : '';
            this.getAlarmList();
        },
        onRadioChange(val) {
            const endTime = dayjs().unix();
            let beginTime;
            switch (val) {
                case '1':
                    beginTime = dayjs().subtract(1, 'hour').unix()
                    break;
                case '2':
                    beginTime = dayjs().subtract(4, 'hour').unix()
                    break;
                case '3':
                    beginTime = dayjs().subtract(12, 'hour').unix()
                    break;
                case '4':
                    beginTime = dayjs().subtract(1, 'day').unix()
                    break;
                case '5':
                    beginTime = dayjs().subtract(3, 'day').unix()
                    break;
                case '6':
                    beginTime = dayjs().subtract(7, 'day').unix()
                    break;
            }
            this.searchForm.beginTime = beginTime;
            this.searchForm.endTime = endTime;
            this.getAlarmList();
        },
        getAlarmList() {
            Core.Api.Alarm.list(
                this.currentPage,
                this.searchForm.projectId || this.projectId,
                this.searchForm.modelId,
                this.searchForm.beginTime,
                this.searchForm.endTime
            ).then((res) => {
                this.total = res.count;
                this.alarmList = res.alarm_list;
            });
        },
        pageChange(page) {
            this.currentPage = page;
            this.getAlarmList();
        },
        async getNameList() {
            try {
                const { project_name_list } = await Core.Api.Project.nameList()
                this.projectNameList = project_name_list
            } catch (error) {
                console.log(error)
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.container {
    background: #f1f4f9;
    @import '@/common/styles/form.scss';
}
</style>